import classNames from 'classnames'
import React from 'react'

import { Select, SelectOption } from '../../../main/components/select'
import { TooltipInput } from '../../../main/components/tooltip-input'
import { PortfolioOptions, SaveToPortfolioInputProps } from './types'

type PortfolioInputProps = {
  portfolios: PortfolioOptions
} & SaveToPortfolioInputProps

export default function PortfolioInput(props: PortfolioInputProps) {
  const handleChange = React.useCallback(
    (ev: React.ChangeEvent<HTMLInputElement>) => {
      const portfolio = ev.currentTarget.value
      if (portfolio.trim().length >= 0 && props.errors?.portfolioName) {
        props.setErrors?.((errors) => ({ ...errors, portfolio: false }))
      }

      props.setState((prev) => ({ ...prev, portfolioName: portfolio }))
    },
    [props]
  )

  const handleSelect = React.useCallback(
    (option: { value: number; label: string }) => {
      props.setState((prev) => ({ ...prev, portfolioId: option.value }))
      props.setErrors?.((errors) => ({ ...errors, portfolioId: false }))
    },
    [props]
  )

  const tooltipContent = props.errors?.portfolioName ? 'Missing portfolio name' : undefined

  return (
    <>
      {props.portfolios.length > 0 ? (
        <div>
          <input name="portfolioId" type="hidden" value={props.state.portfolioId} />
          <Select
            size="small"
            label="Portfolio"
            isHorizontalLabel
            labelClassName="flex-row items-center justify-between"
            className="w-56"
            listProps={{ className: 'min-w-56' }}
            aria-label="Portfolio"
            value={props.state.portfolioId}
            items={props.portfolios}
            onChange={handleSelect}
            hasPopoverViewportHeightLimit
          >
            {props.portfolios.map((item) => (
              <SelectOption key={item.value}>{item.label}</SelectOption>
            ))}
          </Select>
        </div>
      ) : (
        <TooltipInput
          isMobileStyleEnabled={false}
          name="portfolio"
          size="small"
          label="Portfolio"
          isHorizontalLabel
          labelClassName="flex-row items-center justify-between"
          value={props.state.portfolioName}
          onChange={handleChange}
          maxLength={30}
          error={props.errors?.portfolioName}
          className={classNames('w-56', { 'is-error': props.errors?.portfolioName })}
          tooltipContent={tooltipContent}
          tooltipColor="red"
        />
      )}
    </>
  )
}
